import React from 'react';
import { DISMISS_TIMEOUT, SnackbarInterface } from '../../helpers/snackbar';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IconButton } from '../IconButton';
import { Snackbar } from '@xo-union/tk-component-alerts';
import classNames from 'classnames';
import styles from './CopyToClipboardButton.styles.scss';

interface CopyIconButtonProps {
  textToCopy: string;
  dataTestId?: string;
  ariaLabel?: string;
  onCopy?: () => void;
  onCopyMessage?: string;
  className?: string;
}

const CopyToClipboardButton = ({
  textToCopy,
  dataTestId = 'CopyToClipboardButton',
  ariaLabel = 'Copy to clipboard',
  onCopy,
  onCopyMessage = 'Copied to clipboard',
  className = '',
}: CopyIconButtonProps) => {
  const [copyIconToDisplay, setCopyIconToDisplay] = React.useState<'copy' | 'checkmark'>('copy');
  const snackbarRef = React.useRef<SnackbarInterface>();

  const handleOnCopy = () => {
    onCopy && onCopy();

    if (snackbarRef.current) {
      snackbarRef.current.showAndDismiss({
        data: onCopyMessage,
        dismissTimeout: DISMISS_TIMEOUT,
      });
    }

    setCopyIconToDisplay('checkmark');
    setTimeout(() => {
      setCopyIconToDisplay('copy');
    }, DISMISS_TIMEOUT);
  };

  return (
    <>
      <CopyToClipboard text={textToCopy} className={classNames(className, styles.CopyToClipboardButton__button)}>
        <IconButton name={copyIconToDisplay} onClick={handleOnCopy} datatestid={dataTestId} arialabel={ariaLabel} />
      </CopyToClipboard>
      <Snackbar ref={snackbarRef} />
    </>
  );
};

export default CopyToClipboardButton;
